// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Red_Hat_Display/static/RedHatDisplay-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Montserrat/static/Montserrat-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/img/sky.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
html {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

@font-face {
  font-family: "big";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "paragraph";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
h1 {
  font-size: 80px;
  margin: 24px 0px;
  font-family: "big";
  text-align: center;
  color: rgb(69, 102, 124);
}

h2,
h3 {
  font-size: 40px;
  margin: 24px 0px;
  font-family: "big";
  text-align: center;
  color: rgb(69, 102, 124);
}

h4,
p,
a,
button,
label,
input {
  font-size: 24px;
  font-family: "paragraph";
  line-height: 1.6em;
}

button {
  margin: 16px 0px;
  padding: 8px 16px;
  border: 4px solid rgb(69, 102, 124);
  border-radius: 500px;
  background-color: white;
  color: rgb(31, 33, 26);
  transition: background-color 0.3s ease;
}
button:hover {
  cursor: pointer;
  background-color: rgb(69, 102, 124);
  color: rgb(241, 243, 255);
  transition: background-color 0.3s ease;
}

.mobile-only {
  display: none;
}

.down-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 24px;
  z-index: 2;
}
.down-btn .arrow {
  position: relative;
  height: 80px;
  width: 80px;
}
.down-btn .arrow .straight,
.down-btn .arrow .left,
.down-btn .arrow .right {
  position: absolute;
  display: inline-block;
  height: 2px;
  background-color: rgb(31, 33, 26);
}
.down-btn .arrow .straight {
  transform: rotate(90deg);
  top: 35px;
  left: 20px;
  width: 40px;
}
.down-btn .arrow .left {
  transform: rotate(45deg);
  top: 48px;
  left: 20px;
  width: 24px;
}
.down-btn .arrow .right {
  transform: rotate(-45deg);
  top: 48px;
  right: 20px;
  width: 24px;
}
.down-btn:hover {
  cursor: pointer;
}

@media screen and (max-width: 980px) {
  h1 {
    font-size: 40px;
  }
  h2,
  h3 {
    font-size: 32px;
  }
  h4,
  p,
  a,
  button,
  label,
  input {
    font-size: 20px;
  }
  .mobile-only {
    display: flex;
  }
}
.home-page {
  background-color: rgb(241, 243, 255);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: top;
  background-attachment: fixed;
}
.home-page .home-landing {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
}
.home-page .home-landing .foreground {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  opacity: 0.8;
  z-index: 0;
}
.home-page .home-landing .foreground .front-img {
  position: absolute;
}
.home-page .home-landing .foreground .front-img.birds {
  top: 50%;
  right: 4vw;
  transform: translateY(-50%);
  width: 10vw;
}
.home-page .home-landing .foreground .front-img.corner {
  bottom: 0;
  left: 0;
  height: 50vh;
}
.home-page .home-landing .part {
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.home-page .home-landing .part.one {
  min-height: 100vh;
}
.home-page .home-landing .part.one .circles img {
  width: 80px;
  margin: 24px;
}
.home-page .home-landing .part.two {
  justify-content: space-around;
}
.home-page .home-landing .part.two .text-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
}
.home-page .home-landing .part.two .text-content h1 {
  color: rgb(69, 102, 124);
}
.home-page .home-landing .part.two .text-content p.text {
  max-width: 80%;
}
.home-page .home-landing .part.two .down-btn {
  position: relative;
}
.home-page .menu {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  padding-top: 40px;
}
.home-page .menu .multi-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}
.home-page .menu .multi-content .content-container {
  width: 50%;
  text-align: center;
}
.home-page .menu .about-us,
.home-page .menu .services,
.home-page .menu .contact {
  width: 90%;
  padding: 40px 0;
}
.home-page .menu .about-us img,
.home-page .menu .services img,
.home-page .menu .contact img {
  width: 30%;
  object-fit: contain;
}
.home-page .menu .contact {
  text-align: center;
}

@media screen and (max-width: 980px) {
  .home-page {
    background-size: auto 100%;
  }
  .home-page .home-landing .foreground .front-img.corner {
    height: 24vh;
  }
  .home-page .home-landing .part.one {
    min-height: 80vh;
  }
  .home-page .menu .multi-content {
    flex-direction: column-reverse;
    align-items: center;
  }
  .home-page .menu .multi-content img {
    width: 50vw;
  }
  .home-page .menu .multi-content .content-container {
    width: 90vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/main.scss","webpack://./src/styles/home.scss"],"names":[],"mappings":"AASA;;EAEE,UAAA;EACA,SAAA;EACA,sBAAA;ACRF;;ADWA;EACE,kBAAA;EACA,4CAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;ACTF;ADYA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,wBA7Bc;ACmBhB;;ADaA;;EAEE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,wBAtCc;AC4BhB;;ADaA;;;;;;EAME,eAAA;EACA,wBAAA;EACA,kBAAA;ACVF;;ADaA;EACE,gBAAA;EACA,iBAAA;EACA,mCAAA;EACA,oBAnDO;EAoDP,uBAAA;EACA,sBA3DW;EA4DX,sCAAA;ACVF;ADYE;EACE,eAAA;EACA,mCA/DY;EAgEZ,yBAlEU;EAmEV,sCAAA;ACVJ;;ADcA;EACE,aAAA;ACXF;;ADcA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;ACXF;ADaE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;ACXJ;ADaI;;;EAGE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,iCA9FO;ACmFb;ADcI;EACE,wBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;ACZN;ADeI;EACE,wBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;ACbN;ADgBI;EACE,yBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;ACdN;ADkBE;EACE,eAAA;AChBJ;;ADoBA;EACE;IACE,eAAA;ECjBF;EDoBA;;IAEE,eAAA;EClBF;EDqBA;;;;;;IAME,eAAA;ECnBF;EDsBA;IACE,aAAA;ECpBF;AACF;AA5HA;EACE,oCDHY;ECIZ,yDAAA;EACA,0BAAA;EACA,4BAAA;EACA,wBAAA;EACA,4BAAA;AA8HF;AA5HE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AA8HJ;AA5HI;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;AA8HN;AA5HM;EACE,kBAAA;AA8HR;AA5HQ;EACE,QAAA;EACA,UAAA;EACA,2BAAA;EACA,WAAA;AA8HV;AA3HQ;EACE,SAAA;EACA,OAAA;EACA,YAAA;AA6HV;AAxHI;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AA0HN;AAxHM;EACE,iBAAA;AA0HR;AAvHU;EACE,WAAA;EACA,YAAA;AAyHZ;AApHM;EACE,6BAAA;AAsHR;AApHQ;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAsHV;AApHU;EACE,wBDzEI;AC+LhB;AAnHU;EACE,cAAA;AAqHZ;AAjHQ;EACE,kBAAA;AAmHV;AA7GE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AA+GJ;AA7GI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;AA+GN;AA7GM;EACE,UAAA;EACA,kBAAA;AA+GR;AA3GI;;;EAGE,UAAA;EACA,eAAA;AA6GN;AA3GM;;;EACE,UAAA;EACA,mBAAA;AA+GR;AA3GI;EACE,kBAAA;AA6GN;;AAxGA;EACE;IACE,0BAAA;EA2GF;EAtGQ;IACE,YAAA;EAwGV;EAlGM;IACE,gBAAA;EAoGR;EA9FI;IACE,8BAAA;IACA,mBAAA;EAgGN;EA9FM;IACE,WAAA;EAgGR;EA7FM;IACE,WAAA;EA+FR;AACF","sourcesContent":["$light-color: rgb(241, 243, 255);\n$dark-color: rgb(31, 33, 26);\n$primary-color: rgb(69, 102, 124);\n$secondary-color: rgb(43, 45, 36);\n\n$mobile-width: 980px;\n\n$radius: 500px;\n\n*,\nhtml {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n@font-face {\n  font-family: \"big\";\n  src: url(\"../assets/fonts/Red_Hat_Display/static/RedHatDisplay-Medium.ttf\");\n}\n\n@font-face {\n  font-family: \"paragraph\";\n  src: url(\"../assets/fonts/Montserrat/static/Montserrat-Regular.ttf\");\n}\n\nh1 {\n  font-size: 80px;\n  margin: 24px 0px;\n  font-family: \"big\";\n  text-align: center;\n  color: $primary-color;\n}\n\nh2,\nh3 {\n  font-size: 40px;\n  margin: 24px 0px;\n  font-family: \"big\";\n  text-align: center;\n  color: $primary-color;\n}\n\nh4,\np,\na,\nbutton,\nlabel,\ninput {\n  font-size: 24px;\n  font-family: \"paragraph\";\n  line-height: 1.6em;\n}\n\nbutton {\n  margin: 16px 0px;\n  padding: 8px 16px;\n  border: 4px solid $primary-color;\n  border-radius: $radius;\n  background-color: white;\n  color: $dark-color;\n  transition: background-color 0.3s ease;\n\n  &:hover {\n    cursor: pointer;\n    background-color: $primary-color;\n    color: $light-color;\n    transition: background-color 0.3s ease;\n  }\n}\n\n.mobile-only {\n  display: none;\n}\n\n.down-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  bottom: 24px;\n  z-index: 2;\n\n  .arrow {\n    position: relative;\n    height: 80px;\n    width: 80px;\n\n    .straight,\n    .left,\n    .right {\n      position: absolute;\n      display: inline-block;\n      height: 2px;\n      background-color: $dark-color;\n    }\n\n    .straight {\n      transform: rotate(90deg);\n      top: 35px;\n      left: 20px;\n      width: 40px;\n    }\n\n    .left {\n      transform: rotate(45deg);\n      top: 48px;\n      left: 20px;\n      width: 24px;\n    }\n\n    .right {\n      transform: rotate(-45deg);\n      top: 48px;\n      right: 20px;\n      width: 24px;\n    }\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n@media screen and (max-width: $mobile-width) {\n  h1 {\n    font-size: 40px;\n  }\n\n  h2,\n  h3 {\n    font-size: 32px;\n  }\n\n  h4,\n  p,\n  a,\n  button,\n  label,\n  input {\n    font-size: 20px;\n  }\n\n  .mobile-only {\n    display: flex;\n  }\n}\n","@import \"./main.scss\";\n\n.home-page {\n  background-color: $light-color;\n  background-image: url(\"../assets/img/sky.png\");\n  background-size: 100% auto;\n  background-repeat: no-repeat;\n  background-position: top;\n  background-attachment: fixed;\n\n  .home-landing {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    position: relative;\n\n    .foreground {\n      position: fixed;\n      bottom: 0;\n      left: 0;\n      width: 100vw;\n      height: 100vh;\n      opacity: 0.8;\n      z-index: 0;\n\n      .front-img {\n        position: absolute;\n\n        &.birds {\n          top: 50%;\n          right: 4vw;\n          transform: translateY(-50%);\n          width: 10vw;\n        }\n\n        &.corner {\n          bottom: 0;\n          left: 0;\n          height: 50vh;\n        }\n      }\n    }\n\n    .part {\n      min-height: 100vh;\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n\n      &.one {\n        min-height: 100vh;\n\n        .circles {\n          img {\n            width: 80px;\n            margin: 24px;\n          }\n        }\n      }\n\n      &.two {\n        justify-content: space-around;\n\n        .text-content {\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          justify-content: center;\n          min-height: 60vh;\n\n          h1 {\n            color: $primary-color;\n          }\n\n          p.text {\n            max-width: 80%;\n          }\n        }\n\n        .down-btn {\n          position: relative;\n        }\n      }\n    }\n  }\n\n  .menu {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    padding-top: 40px;\n\n    .multi-content {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      justify-content: space-around;\n\n      .content-container {\n        width: 50%;\n        text-align: center;\n      }\n    }\n\n    .about-us,\n    .services,\n    .contact {\n      width: 90%;\n      padding: 40px 0;\n\n      img {\n        width: 30%;\n        object-fit: contain;\n      }\n    }\n\n    .contact {\n      text-align: center;\n    }\n  }\n}\n\n@media screen and (max-width: $mobile-width) {\n  .home-page {\n    background-size: auto 100%;\n\n    .home-landing {\n      .foreground {\n        .front-img {\n          &.corner {\n            height: 24vh;\n          }\n        }\n      }\n\n      .part{\n        &.one{\n          min-height: 80vh;\n        }\n      }\n    }\n\n    .menu {\n      .multi-content {\n        flex-direction: column-reverse;\n        align-items: center;\n\n        img {\n          width: 50vw;\n        }\n\n        .content-container {\n          width: 90vw;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
